import queryString from 'query-string';

const apply = function (url, extraQuery) {
  const parsedUrl = queryString.parseUrl(url).url;
  const currentQuery = extract(url);
  const newQuery = Object.assign(currentQuery, extraQuery);
  return `${parsedUrl}?${queryString.stringify(newQuery)}`;
};

const extract = (url) => queryString.parseUrl(url).query;

export { apply, extract };
